import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  /** Sınır tetiklendiğinde gösterilecek bağlam ("Sipariş listesi" gibi). */
  where?: string;
}

interface State {
  error: Error | null;
}

/**
 * Beklenmeyen istemci hatasında beyaz ekran yerine okunabilir bir panel gösterir.
 *
 * Eski panelde JS hatası (ör. production.php:603'teki null addEventListener)
 * sayfayı sessizce yarım bırakıyordu; kullanıcı butonun neden çalışmadığını
 * bilmiyordu. Burada hata görünür olur ve kaydın durumu doğrulanana kadar
 * "işlem başarılı" izlenimi verilmez.
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Arayüz hatası", this.props.where ?? "", error, info.componentStack);
  }

  private handleReload = () => {
    this.setState({ error: null });
    window.location.reload();
  };

  override render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="mx-auto max-w-2xl p-6">
        <div className="rounded-lg border border-red-300 bg-red-50 p-5">
          <h1 className="text-base font-semibold text-red-900">
            Bu ekran yüklenirken bir hata oluştu
          </h1>
          <p className="mt-2 text-sm text-red-900">
            {this.props.where ? `Bölüm: ${this.props.where}. ` : ""}
            Yaptığınız son işlemin kaydedilip kaydedilmediğini listeden doğrulayın —
            bu ekran hatayı gizlemez.
          </p>
          <pre className="mt-3 max-h-40 overflow-auto whitespace-pre-wrap rounded bg-white/70 p-2 text-xs text-red-800">
            {error.message}
          </pre>
          <div className="mt-4 flex gap-2">
            <button type="button" className="btn-danger" onClick={this.handleReload}>
              Sayfayı yenile
            </button>
            <a href="/" className="btn-secondary">
              Panele dön
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
